import React from 'react';
import { getText } from '../../../../../services/text/text-service';
import { LeadText, Title } from '@gje/typography/lib';
import useMobile from '../../../../../hooks/useMobile';
import classNames from 'classnames';

interface HeaderProps {
    customerName: string;
    carData: string;
}

export const SecondStepHeader: React.FunctionComponent<HeaderProps> = ({
    customerName,
    carData
}) => {
    const isMobile = useMobile();
    return (
        <div
            className={classNames(
                `text-center margin-bottom-${isMobile ? '52' : '104'}`,
                { 'margin-top-26': isMobile }
            )}>
            <Title
                tag="h2"
                className={`margin-bottom-${isMobile ? '13' : '39'}`}>
                {customerName}
            </Title>
            <LeadText className={'title-without-bold'}>
                {getText('webshopsweden.products.car.buyingHeader')}
            </LeadText>
            <LeadText className={'title-without-bold'}>{carData}</LeadText>
        </div>
    );
};
